import React from 'react';
import PropTypes from 'prop-types';
import Checkmark from '../../../../shared/icons/icon-checkmark2.svg';
import CloseCircle from '../../../../shared/icons/icon-close-circle.svg';


const BoolAttr = function BoolAttrComponent({ value }) {
  const truthy = value && value !== 'No';

  return (
    <div className="product-table__checkmark">
      { truthy ?
        <Checkmark className="product-table__checkmark-icon-true" /> :
        <CloseCircle className="product-table__checkmark-icon-false" />
      }
      <span>{ truthy ? 'Yes' : 'No'}</span>
    </div>
  );
};

BoolAttr.propTypes = {
  value: PropTypes.string.isRequired,
};

export default BoolAttr;
